"use client";

import { c as _c } from "react/compiler-runtime";
import { refreshTprWorkflowProgress } from "@/configuration/groups/tpr/components/workflow-progress";
import { useInvalidateServerComponent } from "@/src/components/server/client-provider";
import { Button } from "@/src/components/shadcn/ui/button";
import { toast } from "@/src/hooks/use-toast";
import { useApproveTaskMutation, useLocalTaskUpdateMutation } from "@/src/lib/data-fetchers/tasks-fetchers";
import { type Task, TaskStatus } from "@/src/models/task";
export function TprOpsContinueButton(t0) {
  const $ = _c(13);
  const {
    task,
    label: t1,
    pendingLabel: t2,
    successTitle,
    successDescription,
    errorTitle: t3
  } = t0;
  const label = t1 === undefined ? "Continue" : t1;
  const pendingLabel = t2 === undefined ? "Continuing..." : t2;
  const errorTitle = t3 === undefined ? "Unable to continue the workflow" : t3;
  const approvalMutation = useApproveTaskMutation();
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      invalidateOnSettled: false
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const localTaskUpdateMutation = useLocalTaskUpdateMutation(t4);
  const invalidateInstructions = useInvalidateServerComponent("getReferralInstructions");
  let t5;
  if ($[1] !== approvalMutation || $[2] !== errorTitle || $[3] !== invalidateInstructions || $[4] !== localTaskUpdateMutation || $[5] !== successDescription || $[6] !== successTitle || $[7] !== task) {
    t5 = async () => {
      ;
      try {
        await approvalMutation.mutateAsync({
          taskId: task.id,
          approved: true
        });
        localTaskUpdateMutation.mutate({
          ...task,
          status: TaskStatus.PROCESSING
        });
        refreshTprWorkflowProgress(invalidateInstructions);
        toast({
          title: successTitle,
          description: successDescription
        });
      } catch (t6) {
        const error = t6;
        toast({
          title: errorTitle,
          description: error instanceof Error ? error.message : "Refresh the task and try again.",
          variant: "destructive"
        });
      }
    };
    $[1] = approvalMutation;
    $[2] = errorTitle;
    $[3] = invalidateInstructions;
    $[4] = localTaskUpdateMutation;
    $[5] = successDescription;
    $[6] = successTitle;
    $[7] = task;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const handleContinue = t5;
  const t6 = approvalMutation.isPending || localTaskUpdateMutation.isPending;
  const t7 = approvalMutation.isPending ? pendingLabel : label;
  let t8;
  if ($[9] !== handleContinue || $[10] !== t6 || $[11] !== t7) {
    t8 = <Button onClick={handleContinue} disabled={t6}>{t7}</Button>;
    $[9] = handleContinue;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
}